<template>
  <div class="white-container full-page-container common-table">
    <div class="relevancyGoodsTitle">关联商品配置</div>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item class="search-form-item">
        <el-input v-model="search.sku" placeholder="搜索商品名称或SKU" prefix-icon="el-icon-search" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <tableList ref="multipleTable" size="small" :table-query="search" :query-function="$Api.equipment.getEquipmentBySku" style="width: 100%">
        <el-table-column prop="productNo" label="商品SKU" />
        <el-table-column prop="productName" label="商品名称" />
        <el-table-column prop="categories" label="分类">
          <template v-slot="{ row }">
            <template v-if="row.categories">
              <div v-for="item in row.categories.split('，')" :key="item">{{ item }}</div>
            </template>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column prop="newFlag" label="是否新品">
          <template v-slot="{ row }">
            {{ row.newFlag === 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="mediaLink" label="商品图片">
          <template v-slot="{row}">
            <div class="img-box" style="width:75px; height: 75px">
              <img v-if="row.isDelete === 1" class="invalid-flag" src="@/assets/images/product-invalid.svg">
              <img v-if="row.mediaLink" class="product-img" :src="row.mediaLink" alt="">
              <div v-else style="line-height: 75px;">--</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="qty" label="库存" />
        <el-table-column prop="soldQty" label="销量" />
        <el-table-column prop="isHot" label="是否热卖商品">
          <template v-slot="{ row }">
            {{ row.isHot === 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="{row}">
            <el-button v-if="row.isDelete === 0" size="small" type="text" class="link-color" @click="handleAdd(row)">添加</el-button>
          </template>
        </el-table-column>
      </tableList>
    </div>
    <div class="addsGoodsTitle">已添加商品</div>
    <el-table ref="multipleTable1" size="small" :data="addList" style="width: 100%">
      <el-table-column prop="productNo" label="商品SKU" />
      <el-table-column prop="productName" label="商品名称" />
      <el-table-column prop="categories" label="分类">
        <template v-slot="{ row }">
          <template v-if="row.categories">
            <div v-for="item in row.categories.split('，')" :key="item">{{ item }}</div>
          </template>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column prop="newFlag" label="是否新品">
        <template v-slot="{ row }">
          {{ row.newFlag === 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column prop="mediaLink" label="商品图片">
        <template v-slot="{row}">
          <div class="img-box" style="width:75px; height: 75px">
            <img v-if="row.isDelete === 1" class="invalid-flag" src="@/assets/images/product-invalid.svg">
            <img v-if="row.mediaLink" class="product-img" :src="row.mediaLink" alt="">
            <div v-else style="line-height: 75px;">--</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="qty" label="库存" />
      <el-table-column prop="soldQty" label="销量" />
      <el-table-column prop="isHot" label="是否热卖商品">
        <template v-slot="{ row }">
          {{ row.isHot === 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="{row}">
          <el-button size="small" type="text" class="link-color" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex btns">
      <el-button type="info" @click="cancelBtn">取消</el-button>
      <el-button type="primary" @click="submit">保存并应用</el-button>
    </div>
  </div>
</template>

<script>
import tableList from "@/components/TableList";

export default {
  components: {
    tableList,
  },

  data() {
    return {
      id: null,
      addList: [],
      search: {
        sku: '',
      },
      searchList: [],
    };
  },
  mounted() {
    const { query } = this.$route;
    if (query.id) {
      this.id = query.id;
      this.initData();
    }
  },
  methods: {
    // 初始化数据
    initData() {
      this.$Api.equipmentTask.getSearchAddedGoods(Number(this.id)).then(res => {
        if (res) {
          this.addList = res;
        }
      });
    },
    // 搜索
    searchSubmit() {
      this.$refs['multipleTable'].searchAndReset();
    },
    reset() {
      this.search = this.$options.data.call(this).search;
      this.$nextTick(() => {
        this.$refs['multipleTable'].searchAndReset();
      });
    },
    // 添加
    handleAdd(row) {
      const len = this.addList.filter(item => item.productNo === row.productNo);
      if (len.length) {
        this.$message.warning('请不要添加重复商品');
        return;
      }
      this.addList.push(row);
    },
    // 删除
    handleDelete(row) {
      this.addList = this.addList.filter(item => item.productNo !== row.productNo);
    },
    // 取消
    cancelBtn() {
      this.$router.go(-1);
    },
    // 保存并应用
    submit() {
      if (!this.id) return;
      const skus = this.addList.map(item => item.productNo);
      this.$Api.equipmentTask.postPreserveActivityGoods({
        equipmentSkus: skus,
        taskClockId: Number(this.id),
      }).then(res => {
        this.$message.success('保存成功');
        setTimeout(() => {
          this.$router.go(-1);
        }, 2000);
      });
    },
  },
};
</script>

<style scoped>
.table-wrap {
  position: relative;
  padding-bottom: 80px;
}
.img-box {
  position: relative;
  .invalid-flag {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%) rotateZ(20deg);
    z-index: 2;
    width: 92px;
    height: 36px;
  }
  .product-img {
    width: 100%;
    height: 100%;
  }
}
.relevancyGoodsTitle {
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  color: #494949;
  margin: 0 0 30px 0;
}
.flexImg {
  width: 75px;
  height: 75px;
}
.addsGoodsTitle {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #494949;
  margin: 50px 0 30px 0;
}
.btns {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 30px;
}
</style>
